<div class="modal-header">
  <h4 class="modal-title">
    {{ 'dataconnection.sorting.upload' | translate }} - {{ connection.name }}
  </h4>
</div>
<div class="modal-body d-flex flex-column gap-3">
  <p>
    {{
      'dataconnection.sorting.uploadHelp'
        | translate: { key: connection.configuration.keyField }
    }}
  </p>
  @if (!allowed) {
    <p-message severity="warn">{{
      'dataconnection.sorting.errors.permission' | translate
    }}</p-message>
  }
  <p-fileupload
    #picker
    mode="basic"
    accept=".csv,.json"
    [customUpload]="true"
    [multiple]="false"
    [chooseLabel]="'browse' | translate"
    [disabled]="!allowed || preparing() || uploading() || pending"
    (onSelect)="selectFile($event, picker)"
  >
    <ng-template #filelabel>
      <span class="text-break">{{ fileName() }}</span>
    </ng-template>
  </p-fileupload>
  @if (preparing() || uploading()) {
    <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
    <span role="status">{{
      (preparing()
        ? 'dataconnection.sorting.reading'
        : 'dataconnection.sorting.uploading'
      ) | translate
    }}</span>
  }
  @if (status(); as current) {
    <div aria-live="polite" class="d-flex flex-column gap-2">
      <strong>{{
        'dataconnection.sorting.status.' + current.status | translate
      }}</strong>
      @if (current.status === 'IMPORTING' || current.status === 'COMPLETED') {
        <p-progressbar [value]="progress" />
        <span>{{
          'dataconnection.sorting.progress'
            | translate: { processed: current.processed, total: current.total }
        }}</span>
      } @else if (pending && polling()) {
        <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
      }
      @if (current.status === 'FAILED') {
        <p-message severity="error">{{ failureKey | translate }}</p-message>
        <p-message severity="warn">{{
          'dataconnection.sorting.partialUpdates' | translate
        }}</p-message>
      }
      @if (pending) {
        <p>{{ 'dataconnection.sorting.continuesAfterClose' | translate }}</p>
      }
    </div>
  }
  @if (errorKey(); as error) {
    <p-message severity="error">{{ error | translate }}</p-message>
  }
</div>
<div class="modal-footer">
  <p-button
    [label]="'close' | translate"
    [outlined]="true"
    [disabled]="uploading()"
    (onClick)="modalRef.close()"
  />
  @if (pending && !polling()) {
    <p-button
      [label]="'dataconnection.sorting.resumeProgress' | translate"
      [disabled]="!allowed"
      (onClick)="resumeProgress()"
    />
  } @else if (
    request() &&
    (status()?.status === 'FAILED' || status()?.status === 'CANCELLED')
  ) {
    <p-button
      [label]="'dataconnection.sorting.resubmit' | translate"
      [disabled]="!allowed"
      (onClick)="resubmit()"
    />
  } @else if (!status()) {
    <p-button
      [label]="'dataconnection.sorting.upload' | translate"
      [loading]="uploading()"
      [disabled]="!allowed || !request() || preparing() || uploading()"
      (onClick)="upload()"
    />
  }
</div>
